import { render, staticRenderFns } from "./AccountRecord.vue?vue&type=template&id=4e05eb26&scoped=true&"
import script from "./AccountRecord.vue?vue&type=script&lang=ts&"
export * from "./AccountRecord.vue?vue&type=script&lang=ts&"
import style0 from "./AccountRecord.vue?vue&type=style&index=0&id=4e05eb26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e05eb26",
  null
  
)

export default component.exports